import { render, staticRenderFns } from "./NewUserForm.vue?vue&type=template&id=01d70030&scoped=true&"
import script from "./NewUserForm.vue?vue&type=script&lang=js&"
export * from "./NewUserForm.vue?vue&type=script&lang=js&"
import style0 from "./NewUserForm.vue?vue&type=style&index=0&id=01d70030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d70030",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCol,VFileInput,VRow,VSwitch,VTextField,VTextarea})
